// Shows the official logo when provided, otherwise a neutral placeholder slot.
export const LogoSlot = ({ src, alt, label, className = "", testId }) => {
  if (src) {
    return <img src={src} alt={alt} className={`object-contain ${className}`} data-testid={testId} />;
  }
  return (
    <div
      data-testid={testId}
      className={`relative flex items-center justify-center rounded-full border border-dashed border-gold/45 bg-white/[0.02] ${className}`}
    >
      <div className="absolute inset-[10%] rounded-full border border-white/5" />
      <span className="px-3 text-center font-mono text-[10px] uppercase leading-tight tracking-[0.2em] text-zinc-400">
        {label}
      </span>
    </div>
  );
};
